import type { ReactNode } from "react";
import { UiFeatureFlagNames } from "@/gql/graphql";
import DeviceSerialLink, {
  type DeviceIdentity,
} from "@/components/DeviceSerialLink";
import { useFeatureFlags } from "@/context/FeatureFlags";

type DeviceToastMessage = (
  message: ReactNode,
  device?: DeviceIdentity
) => ReactNode;

type DeviceToastMessageContentProps = {
  message: ReactNode;
  device: DeviceIdentity;
};

const DeviceToastMessageContent = ({
  message,
  device,
}: DeviceToastMessageContentProps) => {
  return (
    <>
      {message} <DeviceSerialLink device={device} />
    </>
  );
};

const createDeviceToastMessage = (
  deviceLinksEnabled: boolean
): DeviceToastMessage => {
  const deviceToastMessage = (message: ReactNode, device?: DeviceIdentity) => {
    if (!deviceLinksEnabled || device === undefined) {
      return message;
    }

    return <DeviceToastMessageContent message={message} device={device} />;
  };

  return deviceToastMessage;
};

const useDeviceToastMessage = (): DeviceToastMessage => {
  const { features } = useFeatureFlags();
  const deviceLinksEnabled = features[UiFeatureFlagNames.UxUpdate] === true;

  return createDeviceToastMessage(deviceLinksEnabled);
};

export { useDeviceToastMessage };
